import React, { useContext, useRef, useEffect, useState, useCallback } from 'react';

import * as S from './BenefitsStyles';
import DisplayContext from 'UtilityComponents/displayContext';
import ActionButtons from '../actionButtons/actionButtons';
import {
	ResponsiveContainer,
	FlexDiv,
	Heading,
	SubTitle,
	GenericP
} from 'commonStyles';
import Loader from 'common/Loader/Loader';
import { serverBenefitsListData, SIGNUP_BTN_TEXT } from '../../config';
import { LandingSpriteIcon } from '../../Styles';
import { loadNextComponent, trackClickEvents } from '../../utils';
import { getMyBizBenefits } from '../../landingApi';
import landingContext from '../../landingContext';
import { LANDING_CONSTS, PATHS } from 'AppConstants';

const Benefits = ({ showNextComp, nextComp, isScollView }) => {
	const refHtml = useRef();
	const compRef = useRef();
	const displayName = useContext(DisplayContext).isMobile;
	const { appSsrData = {}, isLoggedInUser } = useContext(landingContext) || {};
	const isMobile = displayName == 'mobile';
	const { heading, subHeading } = serverBenefitsListData;
	const list = appSsrData?.bizBenefits?.benefits || serverBenefitsListData.list;

	const [bizBenefits, setBizBenefits] = useState(list);

	const getDetails = useCallback(async () => {
		if (list.length === 0) {
			const response = await getMyBizBenefits();
			if (response) {
				setBizBenefits(response.bizBenefits.benefits);
			} else {
				setBizBenefits({ error: true });
			}
		}
	}, [list]);

	const goToDetails = (e) => {
		const type = e.target.dataset.type;
		trackClickEvents(`Knowmore_${type}`);
		window.open(`${PATHS.MYBIZ_BENEFIT}?type=${type}`);
	};

	useEffect(() => {
		loadNextComponent(refHtml, showNextComp, nextComp);
		getDetails();
	}, []);

	useEffect(() => {
		if (isScollView && compRef.current) {
			setTimeout(() => {
				if (compRef.current) {
					const headerOffset = 80;
					const parentPos = refHtml.current.offsetTop;
					const elementPosition = parentPos + compRef.current.offsetTop;
					const offsetPosition = elementPosition - headerOffset;

					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
			}, 50);
		}
	}, [isScollView]);
	return (
		<FlexDiv as='section' position='relative' direction='column' directionInMobile='column' ref={refHtml}>
			<S.ImgbgWrap>
				<S.BenefitCurveWrapper>
					<S.BenefitsCurve />
				</S.BenefitCurveWrapper>
				<S.BenefitListOuterWrap ref={compRef} id='Benefits'>
					<S.BenefitListTitleWrap>
						<ResponsiveContainer isNoBTPadd>
							<SubTitle
								fSize={`${isMobile ? '28px' : '48px'}`}
								color='#4a4a4a'
								bottom_M='16'>
								{heading}
							</SubTitle>
							<GenericP color='#4a4a4a' fsize={isMobile ? '16px' : '22px'}>
								{subHeading}
							</GenericP>
						</ResponsiveContainer>
					</S.BenefitListTitleWrap>
					<S.BenefitsListWrapper>
						{!bizBenefits && <Loader bg='#fff' color='#723b63' margin='0 auto' />}
						{bizBenefits && !bizBenefits.error && bizBenefits.map((data, index) => {
							const { heading, subHeading, benefits = [], type, iconUrl } = data;
							return (
								<S.ExtendCard
									as='article'
									radius='8px'
									boxMargin='0 20px 20px 0'
									boxPadding='32px 22px 32px 32px'
									key={index}
									className='custom-scroll'>
									<header>
										{iconUrl ? <S.typeImg width='40' height='40' src={iconUrl} alt={type} /> :
										<LandingSpriteIcon style={{ marginBottom: '16px' }} icon={type} />}
										<Heading as='h3' f_weight='900' font_size='26'>{heading}</Heading>
										<GenericP fsize='18' color='#000'>
											{subHeading}
										</GenericP>
									</header>
									<S.BenefitsList>
										{benefits.map((data, index) => (
											<li key={index}>
												<LandingSpriteIcon icon='icStar' />
												<p dangerouslySetInnerHTML={{ __html: data }} />
											</li>
										))}
									</S.BenefitsList>
									<S.KnowMoreLink data-type={type} onClick={goToDetails}>KNOW MORE</S.KnowMoreLink>
								</S.ExtendCard>
							);
						})}
					</S.BenefitsListWrapper>
				</S.BenefitListOuterWrap>
			</S.ImgbgWrap>
			<ResponsiveContainer isNoBTPadd>
				<S.BtnOuterWrapper>
					<GenericP fsize={`${isMobile ? '16px' : '24px'}`} f_weight='900' bottom_M='24'>
						Grab all the corporate benefits by creating your account now
					</GenericP>
					<ActionButtons show={isLoggedInUser ? LANDING_CONSTS.SIGNUP : LANDING_CONSTS.ALL} signupTxt={isLoggedInUser ? SIGNUP_BTN_TEXT.loggedin : SIGNUP_BTN_TEXT.loggedOut} indexNo='3' />
				</S.BtnOuterWrapper>
			</ResponsiveContainer>
		</FlexDiv>
	);
};
export default Benefits;
